var map = {
	"./nav-links.config.1.fr-CA.json": "6M6w",
	"./nav-links.config.1.json": "GT4H",
	"./nav-links.config.10.json": "UyAm",
	"./nav-links.config.11.json": "q+Ck",
	"./nav-links.config.12.json": "aRhd",
	"./nav-links.config.13.fr-BE.json": "k+AJ",
	"./nav-links.config.13.json": "VoZ5",
	"./nav-links.config.14.json": "V930",
	"./nav-links.config.15.json": "Y+nE",
	"./nav-links.config.16.de-LU.json": "ide0",
	"./nav-links.config.16.json": "sM9K",
	"./nav-links.config.17.json": "R1n1",
	"./nav-links.config.18.json": "Zq+0",
	"./nav-links.config.19.json": "aU8S",
	"./nav-links.config.2.json": "pwsO",
	"./nav-links.config.20.json": "D5N8",
	"./nav-links.config.3.json": "Jug1",
	"./nav-links.config.4.json": "3XhT",
	"./nav-links.config.5.json": "K8bl",
	"./nav-links.config.6.json": "W4no",
	"./nav-links.config.7.json": "/w0i",
	"./nav-links.config.8.fr-CA.json": "97QQ",
	"./nav-links.config.8.json": "3DFi",
	"./nav-links.config.9.json": "llN2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "C/rK";